import React from 'react';

const AuctionMyCar = () => {
    return (
        <div>
            Owner Verification
        </div>
    )
};

export default AuctionMyCar;